const DEFAULT_PAGE_SIZE = 5;
const DEFAULT_LOCALE = 'en-US';
const CMX_BUNDLE_NAME = 'LEARN-widget';
const MAX_IMAGE_WIDTH = 200;
const MAX_IMAGE_HEIGHT = 200;
export default {
  DEFAULT_PAGE_SIZE,
  DEFAULT_LOCALE,
  CMX_BUNDLE_NAME,
  MAX_IMAGE_WIDTH,
  MAX_IMAGE_HEIGHT
};
//# sourceMappingURL=defaults.js.map